// To-Do: Move files from queries.ts to here or domain-specific files

import { useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query'
import { useLoaderData } from '@tanstack/react-router'
import { GlobalStateModel } from '@/models.ts'

export async function fetchAuthenticated(context: GlobalStateModel, path: string, options?: RequestInit, skipVersionCheck?: boolean): Promise<Response> {
    const accessToken = await context.msalTokenFn();
    const fetchUrl = new URL(path, context.appUrl).href;
    if (options === undefined) {
        options = {}
    }
    options.headers = (options.headers === undefined) ? new Headers() : new Headers(options.headers);
    const bearer = `Bearer ${accessToken}`
    options.headers.set("Authorization", bearer)
    return fetch(fetchUrl, options).then(res => {
        // Reload page if receive 401 response, to redirect to MSAL login
        if (res.status === 401) window.location.reload();

        // Reload page if CAPSDAC version has changed
        if (!skipVersionCheck && res.headers.get("CAPSDAC-Version") != null && context.appVersion != res.headers.get("CAPSDAC-Version")) {
            window.stop();
            window.location.href = window.location.href;
        }

        if (!res.ok) throw new Error(`Unexpected response (${res.status}): ${res.statusText}`)
        return res
    })
}

export async function fetchAuthenticatedData<T>(context: GlobalStateModel, path: string, options?: RequestInit, skipVersionCheck?: boolean): Promise<T> {
  return fetchAuthenticated(context, path, options, skipVersionCheck).then(res => {
        try {
            return res.json() as T
        } catch (error) {
            throw new Error(`Failed to parse JSON from ${res.url}: ${(error as Error).message}`);
        }
    })
}

export function useAuthenticatedSuspenseQuery<T>(
    path: string, 
    queryKey: string | string[], 
    refetchInterval: number | false = false
): UseSuspenseQueryResult<T, Error> {
    const globalState = useLoaderData({ from: "__root__" })
    const completeQueryKey = [
        path,
        ...(Array.isArray(queryKey) ? queryKey : [queryKey])
    ];
    return useSuspenseQuery<T>({
        queryKey: completeQueryKey,
        queryFn: () => fetchAuthenticatedData<T>(globalState, path),
        refetchInterval: refetchInterval,
    })
}